import React from 'react';

import { Layout as CleanLayout } from '@clutter/clean';

const FONTS_BASE_URL = 'https://www.clutter.com/fonts';

export const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <CleanLayout fontsBaseUrl={FONTS_BASE_URL}>{children}</CleanLayout>
);
